import { Row, Table } from "antd";
import { useFetchDataCount } from "../../../../../../../../../../lib/hooks/useDefaultFetchDataCount";
import { useFetchData } from "../../../../../../../../../../lib/hooks/useDefaultFetchData";
import ImpoundActivitiesService from "../../../../../../../../../../services/accounts/impounds/activities";
import { useTableColumns } from "./hooks/useTableColumns";
import { SimpleTablePagination } from "../../../../../../../../../../components/SimpleTablePagination";
import { Footer } from "../common/Footer";
import { HeaderTools } from "./HeaderTools";
import { useCallback } from "react";
import { EditModal } from "./EditModal";
import { IImpoundActivity } from "../../../../../../../../../../types/ImpoundActivity";
import { TRequest } from "../common/types";
import { useDefualtOnRow } from "../../../../../../../../../../lib/hooks/useDefaultOnRow";
import { IImpoundSingle } from "../../../../../../../../../../types/Impounds";
import "./styles.scss";

type ActivityDetailsProps = {
  impoundAccount: IImpoundSingle | null;
  parentId: string | undefined;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setParentId: React.Dispatch<React.SetStateAction<string | null>>;
};

export const ActivityDetails = ({ impoundAccount, parentId, setIsOpen, setParentId }: ActivityDetailsProps) => {
  const {
    isLoading: isCountLoading,
    total,
    request,
    onPageChange,
    fetchCount
  } = useFetchDataCount<{ impoundId: string | null }>(ImpoundActivitiesService, {
    impoundId: impoundAccount?.id || null
  });

  const { isLoading, data, fetchData } = useFetchData<TRequest, IImpoundActivity>(
    ImpoundActivitiesService,
    request,
    ".activities-table .ant-table-content"
  );

  const reloadData = useCallback(() => {
    fetchData();
    fetchCount();
  }, [fetchCount, fetchData]);

  const { columns, openedActivityId, setOpenedActivityId } = useTableColumns(reloadData);

  const { onRow } = useDefualtOnRow(setOpenedActivityId);

  return (
    <>
      <Row className="d-block w-100 activities__container">
        <HeaderTools
          contractId={parentId || ""}
          impoundId={impoundAccount?.id || ""}
          balanceBeginningYear={impoundAccount?.balanceBeginningYear || null}
        />
        <Row className="d-block px-6 w-100 sidebar-table small-table">
          <Table
            className="w-100 clickable-rows-table activities-table"
            dataSource={data}
            columns={columns}
            pagination={false}
            rowKey="id"
            loading={isLoading}
            onRow={onRow}
          />
          {total > 20 && (
            <SimpleTablePagination
              isLoading={isCountLoading}
              total={total}
              pageNumber={request.pageNumber}
              onPageChange={onPageChange}
              pageSize={request.pageSize}
            />
          )}
        </Row>
        <EditModal activityId={openedActivityId} setActivityId={setOpenedActivityId} reloadData={fetchData} />
      </Row>
      <Footer setId={setParentId} setIsOpen={setIsOpen} />
    </>
  );
};
